import { axios_api, IMPORT_MENU_ITEMS_AS_EXCEL, UPDATE_MENU_ITEMS_VIA_EXCEL } from "../../../api";
import { uploadSingleFileAsync } from "../../../helpers/uploadFilesAsync";



export const downloadMenuItemsAsExcelAsync = async (uuid: string) => {
    const fileName = "menu_items.xlsx"; // ✅ add proper extension

    try {
        const response = await axios_api.get(
            `${IMPORT_MENU_ITEMS_AS_EXCEL}?outlet_uuid=${uuid}`,
            { responseType: "blob" } // use "blob" for browser
        );

        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const fileURL = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        // cleanup
        link.remove();
        window.URL.revokeObjectURL(fileURL);

        console.log(`✅ File downloaded: ${fileName}`);
    } catch (error) {
        console.error("❌ Error downloading Excel:", error);
    }
};


export const downloadMenuItemsAsCSVAsync = async (uuid: string) => {
    const fileName = "menu_items.csv"; // ✅ add proper extension

    try {
        const response = await axios_api.get(
            `${IMPORT_MENU_ITEMS_AS_EXCEL}?outlet_uuid=${uuid}`,
            { responseType: "blob" } // use "blob" for browser
        );

        // Create a Blob from the CSV string
        const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });

        // Create a link element
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName; // File name

        // Append link to body, trigger click and remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        console.log(`✅ File downloaded: ${fileName}`);
    } catch (error) {
        console.error("❌ Error downloading Excel:", error);
    }
};



export const UpdateMenuItemsViaExcelAsync = async (outlet_uuid: string, file: File) => {
    try {
        const path = await uploadSingleFileAsync({
            file,
            moduleName: "INVENTORY",
            asPayload: {
                product_name: file.name,
                file_name: file.name
            }
        })
        const response = await axios_api.post(UPDATE_MENU_ITEMS_VIA_EXCEL,
            {
                file_path: path,
                outlet_uuid
            }
        );
        console.log(`✅ File Uploaded Successfully`);
    } catch (error) {
        console.error("❌ Error downloading Excel:", error);
    }
};